import React from "react";
import PrintSafesMain from "../PrintSafesMain";

export default function ReviewJardReport(props) {
    return (
        <div>
            <PrintSafesMain  typePrint={1} docNamePdf={"RevewJard.pdf"} docName={"RevewJard"}/>
        </div>
    );
}


